import React from 'react'
import { TwEmoji } from '@t-one-internal/design-system'
import type { RecognitionType, RecognitionTypeConfig } from '../../../../types/recognition'

interface TypeStepProps {
  selectedType: RecognitionType | null
  onSelect: (type: RecognitionType) => void
  availableTypes: RecognitionTypeConfig[]
}

const TypeStep: React.FC<TypeStepProps> = ({ selectedType, onSelect, availableTypes }) => {
  return (
    <div>
      <p className="text-sm font-semibold text-foreground mb-3">Choose recognition type</p>
      <div className="grid grid-cols-2 gap-3">
        {availableTypes.map((t: RecognitionTypeConfig) => (
          <button
            key={t.id}
            onClick={() => onSelect(t.id)}
            className={`p-4 rounded-xl text-center transition-all border ${
              selectedType === t.id
                ? 'bg-primary/10 border-primary/40 shadow-sm'
                : 'bg-muted hover:bg-muted/80 border-transparent'
            }`}
          >
            <span className="block mb-2"><TwEmoji emoji={t.icon} size={32} /></span>
            <p className="text-sm font-semibold text-foreground">{t.label}</p>
            <p className="text-xs text-muted-foreground mt-1">{t.desc}</p>
          </button>
        ))}
      </div>
    </div>
  )
}

export default TypeStep
